import React from "react";
import { Box, Typography, Paper } from "@mui/material";

export default function Support() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
        padding: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          textAlign: "center",
          maxWidth: 600,
          backgroundColor: "#ffffff",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: 2,
            color: "#1E243E",
          }}
        >
          Support
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#1E243E",
          }}
        >
          For questions, or to report a bug, message us on{" "}
          <a
            href="https://wa.me/+9613379747"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "#1E243E",
              fontWeight: "bold",
            }}
          >
            WhatsApp
          </a>
        </Typography>
      </Paper>
    </Box>
  );
}
